<template>
  <mrc_ess_skeleton_loader :loading="skLoading">
    <div>
      <mrc_ess_iconGroup
        :is_disabled="disabled"
        :showEdit="hasBtn('edit-menu')"
        :show_del="hasBtn('delete-menu')"
        @handleReturn="handleReturn"
        @handleEdit="handleEdit"
        @handleDel="handleDel"
      ></mrc_ess_iconGroup>
      <v-form ref="menuDetailRef">
        <v-card>
          <v-card-text>
            <v-row>
              <!-- <v-col cols="12"
                     v-if="$store.state.uuid"
                     sm="2">
                <mrc_ess_switch :label="
                    detailData.is_show
                      ? $t('label_To_enable_the')
                      : $t('label_disable')
                  "
                                color="primary"
                                v-model="detailData.is_show"
                                :readonly="disabled"
                                :true-value="1"
                                :false-value="0"></mrc_ess_switch>
              </v-col>
              <v-col cols="12"
                     sm="5"
                     offset-sm="5"
                     style="justify-content: flex-end">
                <span v-if="uuid">id: {{ uuid }}</span>
              </v-col> -->
              <v-col cols="auto" v-if="$store.state.uuid">
                <mrc_ess_switch
                  :label="
                    detailData.is_show
                      ? $t('label_To_enable_the')
                      : $t('label_disable')
                  "
                  color="primary"
                  v-model="detailData.is_show"
                  :readonly="disabled"
                  :true-value="1"
                  :false-value="0"
                ></mrc_ess_switch>
              </v-col>
              <v-col class="d-flex justify-end">
                <div v-if="uuid">id: {{ uuid }}</div>
              </v-col>
              <v-col cols="12" sm="12">
                <mrc_ess_multiText
                  :readonly="disabled"
                  :label="$t('label_Menu_name') + '*'"
                  :isNational="judegNational('menu_name')"
                  v-model="detailData.menu_name"
                  style="width: 100%"
                  :error-messages="
                    $errors(
                      'detailData',
                      'menu_name',
                      requiredRule.concat(nocharacter)
                    )
                  "
                >
                </mrc_ess_multiText>
              </v-col>
              <v-col cols="12" sm="12">
                <mrc_ess_multiText
                  :label="$t('label_describe') + '*'"
                  :isNational="judegNational('menu_description')"
                  :readonly="disabled"
                  style="width: 100%"
                  v-model="detailData.menu_description"
                  :error-messages="
                    $errors(
                      'detailData',
                      'menu_description',
                      requiredRule.concat(nocharacter)
                    )
                  "
                >
                </mrc_ess_multiText>
              </v-col>
              <v-col cols="auto">
                <v-checkbox
                  color="primary"
                  :disabled="disabled"
                  @click="checkboxclick"
                  v-model="detailData.is_catalog"
                  :true-value="1"
                  :false-value="0"
                  :label="
                    $t('label_Directories_do_not_contain_functionality') + '*'
                  "
                ></v-checkbox>
              </v-col>
              <v-col>
                <!-- <mrc_ess_prompt
                  :label="$t('label_Corresponding_function') + '*'"
                  v-show="detailData.is_catalog"
                  :rules="false"
                  :errMsg="$errors('detailData', 'function_uuid', requiredRule)"
                  :disabled="disabled"
                  v-model="detailData.function_uuid"
                  prompt_name="function_module_parent"
                >
                </mrc_ess_prompt> -->

                <mrc_ess_autoComplete
                  :label="
                    $t('label_Corresponding_function') +
                    (detailData.is_catalog ? '' : '*')
                  "
                  functionView
                  :readonly="disabled"
                  :disabled="Boolean(detailData.is_catalog)"
                  :error-messages="
                    $errors('detailData', 'function_uuid', requiredRule)
                  "
                  v-model="detailData.function_uuid"
                  prompt_name="function_module_parent"
                >
                </mrc_ess_autoComplete>
                <!-- <mrc_ess_input :disabled="true"
                               :readonly='disabled'
                               :label="$t('label_Corresponding_function') + '*'"
                               v-show="!detailData.is_catalog">
                </mrc_ess_input> -->
              </v-col>
              <v-col cols="12">
                <!-- :errMsg="$errors('detailData','tricode_parent',requiredRule)" -->
                <mrc_ess_prompt
                  :label="$t('label_Menu_superior_name')"
                  :rules="false"
                  :disabled="disabled"
                  v-model="detailData.tricode_parent"
                  :select_arr="menu_parent_list"
                >
                </mrc_ess_prompt>
              </v-col>

              <v-col cols="12" sm="6">
                <!-- <mrc_ess_brandupload v-model="detailData.menu_icon"
                                   :label="$t('label_upload_image')"
                                   :disabled='disabled'
                                   @deleteicon='deleteicon'
                                   @changeimgSrc='changeimgSrc'></mrc_ess_brandupload> -->
                <mrc_ess_multiText
                  :label="$t('label_upload_image')"
                  :isNational="judegNational('menu_icon')"
                  :readonly="disabled"
                  style="width: 100%"
                  v-model="detailData.menu_icon"
                  :error-messages="$errors('detailData', 'menu_icon', urlRule)"
                >
                </mrc_ess_multiText>
              </v-col>
              <v-col cols="12" sm="6">
                <!-- <mrc_ess_prompt :label="$t('label_color')"
                                :rules='false'
                                colorView
                                :disabled='disabled'
                                v-model="detailData.menu_color">
                </mrc_ess_prompt> -->
                <!-- <mrc_ess_dictName v-model="detailData.menu_color"
                                  :disabled="disabled"
                                  colorView
                                  :chips="false"
                                  :label="$t('label_color')"
                                  dict_name="set-color">
                </mrc_ess_dictName> -->
                <mrc_ess_colorPicker
                  v-model="detailData.menu_color"
                  :readonly="disabled"
                >
                </mrc_ess_colorPicker>
                <!-- <mrc_ess_dictName
                  v-model="detailData.menu_color"
                  :disabled="disabled"
                  colorView
                  :chips="false"
                  :label="$t('label_color')"
                  dict_name="set-color"
                >
                </mrc_ess_dictName> -->
              </v-col>
              <v-col cols="12" sm="6">
                <mrc_ess_NumInput
                  :readonly="disabled"
                  :error-messages="
                    $errors(
                      'detailData',
                      'sequence',
                      between('000-999').concat(requiredRule)
                    )
                  "
                  :label="$t('label_The_sorting') + '*'"
                  v-model="detailData.sequence"
                ></mrc_ess_NumInput>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
      <mrc_ess_submitBtn
        v-show="!disabled"
        :loading="loading"
        @cancel="cancel"
        @success="success"
      >
      </mrc_ess_submitBtn>
    </div>
  </mrc_ess_skeleton_loader>
</template>

<script>
import { getBusinessList } from "@/service/api/prompt";
import {
  get_menuDetail,
  add_menu,
  update_menu,
  del_menu,
} from "@/service/api/menu";
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators";
export default {
  components: {},
  props: {},
  data() {
    return {
      skLoading: true,
      loading: false,
      uuid: "",
      disabled: false,
      detailData: {
        menu_name: "",
        menu_description: "",
        sequence: 1, // 排序
        menu_icon: "",
        menu_color: "",
        is_show: 1,
        function_uuid: null,
        is_catalog: 0,
        tricode_parent: "",
      },
      menu_parent_list: [],
      file: "",
      deleteFileList: [],
    };
  },
  validations: {
    detailData: {
      menu_icon: {
        url,
      },
      menu_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      menu_description: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      function_uuid: {
        required: function (val) {
          return !this.detailData.is_catalog ? (val ? true : false) : true;
        },
      },
      // tricode_parent: {

      // },
      // menu_color: {
      //   required,
      // },
      sequence: {
        required,
        between: between(0, 999),
      },
    },
  },
  created() {},
  async mounted() {
    await this.national("mrbase_sys_menus");
    this.skLoading = true;
    const name = this.$store.getters.subPage_name || this.$route.meta.title;
    const uuid = this.$route.params.uuid || this.$store.state.uuid;

    if (uuid) {
      if (this.$store.state.iconstatus) {
        this.disabled = true;
      }
      this.uuid = uuid;
      const detail = await get_menuDetail({ uuid });
      if (detail.code == 200) {
        this.detailData = detail.data;
      }
      if (!this.$store.state.iconstatus) {
        this.disabled = false;
      }
    } else {
      this.disabled = false;
    }
    // 上级菜单高级参照  这里参照名和修新增不一样
    const menu_parent_list = await getBusinessList({
      prompt_name: "menu_parent",
      uuid: this.uuid,
    });
    if (menu_parent_list.code == 200) {
      let data = menu_parent_list.data;
      // data.unshift({ view_fields: this.$t('label_nullData'), value_field: null })
      // const index = data.findIndex(item => item.value_field == this.detailData.tricode)
      // // 这一步是不选他自身 ，把 自己删了就不选自身了
      // if (index != -1 && data[0].view_fields !== this.$t('label_nullData')) {
      //   data.splice(index, 1)
      // }
      this.menu_parent_list = data;
    }
    this.skLoading = false;
  },
  methods: {
    checkboxclick() {
      if (this.detailData.is_catalog == 1) {
        // this.detailData.function_uuid = ''
        this.$set(this.detailData, "function_uuid", "");
      }
    },
    deleteicon(v) {
      if (v.uuid) this.deleteFileList.push(v);
    },
    changeimgSrc(v) {
      this.file = v;
    },
    // 返回上一页
    handleReturn() {
      this.$router.go(-1);
    },
    // 修改按钮
    handleEdit() {
      this.disabled = !this.disabled;
    },
    // 删除
    handleDel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      })
        .then(async () => {
          const del = await del_menu({ uuid: this.detailData.uuid });
          if (del.code == 200) {
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
            this.$router.go(-1);
          }
        })
        .catch(() => {
          // console.log("点了取消")
        });
    },
    // 取消
    async cancel() {
      const detail = await get_menuDetail({ uuid: this.uuid });
      if (detail.code == 200) {
        this.detailData = detail.data;
      }
      this.disabled = true;
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      // })
      //   .then(() => {
      //     this.$router.go(-1)
      //   })
      //   .catch(() => {
      //     console.log('点了取消')
      //   })
    },
    // 提交
    async success() {
      // const isSubmit = this.$refs.menuDetailRef.validate()
      // if (!isSubmit) return
      this.$v.detailData.$touch();
      if (this.$v.detailData.$error) return;
      const obj = this.$clone(this.detailData);
      if (obj.is_catalog) {
        obj.function_uuid = null;
        this.detailData.function_uuid = null;
      }
      if (!obj.tricode_parent) {
        obj.tricode_parent = null;
      }
      // console.log(obj)
      // return
      // 修改
      //上传文件
      this.loading = true;
      if (this.uuid) {
        delete obj.created_utc_datetime;
        delete obj.updated_utc_datetime;
        // let deleteFileUuid = []
        // this.deleteFileList.forEach(item => {
        //   deleteFileUuid.push(item.uuid)
        // })
        // deleteFileUuid = deleteFileUuid.join()
        // this.$uploadFiles(this.file, {
          // module_uuid:'menu',
          //   function_uuid: this.$store.state.menuFunctionUuid,
        //   attachment_data_table: 'mrbase_sys_menus',
        //   attachment_data_field: 'menu_icon',
        //   org_level_uuid: this.$store.state.currentCompany,
        //   // menu_uuid: this.$store.state.uuid,
        //   uuid: this.$store.state.currentCompanyClientUuid
        // }).then(async res => {
        //   let url = ''
        //   if (typeof (res) == 'object' && res != undefined && res.code == 200) {
        //     obj.menu_icon = res.uuid
        //     url = res.url
        //   }
        //   const update = await update_menu({ ...obj, del: deleteFileUuid })
        //   if (update.code == 200) {
        //     this.deleteFileList.forEach(item => {
        //     })
        //     this.loading = false
        //     this.deleteFileList = []
        //     this.$Message({ text: this.$t('message_The_operation_was_successful') })
        //     this.$router.go(-1)
        //   }
        //   else {
        //     this.loading = false
        //     this.$router.go(-1)
        //   }
        // })
        const update = await update_menu({ ...obj });
        if (update.code == 200) {
          const detail = await get_menuDetail({ uuid: this.uuid });
          if (detail.code == 200) {
            this.detailData = detail.data;
          }
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          });
          // this.$router.go(-1)
          this.disabled = !this.disabled;
        }
        this.loading = false;
      } else {
        // 新增
        // await this.$uploadFiles(this.file, {
          // module_uuid:'menu',
          //   function_uuid: this.$store.state.menuFunctionUuid,
        //   attachment_data_table: 'mrbase_sys_menus',
        //   attachment_data_field: 'menu_icon',
        //   org_level_uuid: this.$store.state.currentCompany,
        //   menu_uuid: this.$store.state.uuid,
        //   uuid: this.$store.state.currentCompanyClientUuid
        // }).then(async res => {
        //   if (typeof (res )== 'object' && res != undefined && res.code == 200) {
        //     userres.light_mode_icon = res.uuid
        //   }
        //   const add = await add_menu({ ...obj, del: deleteFileUuid })
        //   if (add.code == 200) {
        //     this.$Message({ text: this.$t('message_added_successfully') })
        //     this.$router.go(-1)
        //   }
        // })
        // this.loading = false
      }
    },
  },
  computed: {
    function_uuid_rules() {
      return !this.detailData.is_catalog ? this.$t("verify_Required") : false;
    },
  },
  watch: {
    disabled: {
      handler(v) {
        if (!this.$store.state.uuid) return;
        if (!v) {
          this.$route.meta.title = "label_edit_menu";
          this.$store.commit("set_page_title", "label_edit_menu");
        } else {
          this.$route.meta.title = "label_view_menu";
          this.$store.commit("set_page_title", "label_view_menu");
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.d-flex {
  align-items: center;
}
</style>
